import { render, staticRenderFns } from "./CarouselCategories.vue?vue&type=template&id=d8a20886&scoped=true&"
import script from "./CarouselCategories.vue?vue&type=script&lang=js&"
export * from "./CarouselCategories.vue?vue&type=script&lang=js&"
import style0 from "./CarouselCategories.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CarouselCategories.vue?vue&type=style&index=1&id=d8a20886&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a20886",
  null
  
)

export default component.exports